import { trimEnd, trimStart } from 'lodash-es'

export function encodeFilterComponent(filterComponent: any) {
  return encodeURIComponent(filterComponent).replace(
    /['()*]/g,
    (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`,
  )
}

export class SubscriptionItem {
  topicPattern: string
  topicParamsValues!: Record<string, Array<string>> | undefined
  shareMode: boolean
  messageHandler: (message: any) => void
  sessionName: string
  topic!: string
  paramsByTopic!: Record<string, any>
  // filter example
  // `payload=${encodeFilterComponent('name="trip"||name="idling"')}`
  topicFilter: string

  constructor({
    topicPattern,
    shareMode,
    messageHandler,
    sessionName,
    topicFilter,
    topicParamsValues,
  }: {
    topicPattern: string
    shareMode: boolean
    messageHandler: (message: any) => void
    sessionName: string
    topicFilter: string
    topicParamsValues?: Record<string, Array<string>>
  }) {
    this.topicPattern = topicPattern
    this.shareMode = shareMode
    this.messageHandler = messageHandler
    this.sessionName = sessionName
    this.topicFilter = topicFilter
    this.topicParamsValues = topicParamsValues
    this.calculateTopic()
  }

  calculateTopic() {
    if (!this.topicPattern || this.topicPattern.length === 0) {
      throw new Error('calculateTopic: pattern is empty')
    }
    // splitted pattern
    const patternSplitted = this.topicPattern.split('/')
    // splitted topic
    const topicSplitted: any[] = []
    // schema params
    const paramsByTopic: Record<string, any> = {}
    for (const j in patternSplitted) {
      // first {, last }
      if (
        patternSplitted[j][0] === '{' &&
        patternSplitted[j][patternSplitted[j].length - 1] === '}'
      ) {
        const paramName = trimEnd(trimStart(patternSplitted[j], '{'), '}')
        paramsByTopic[j] = paramName
        if (this.topicParamsValues?.[paramName]?.length) {
          topicSplitted.push(this.topicParamsValues[paramName].join(','))
        } else {
          topicSplitted.push('+')
        }
      } else {
        topicSplitted.push(patternSplitted[j])
      }
    }

    this.topic = topicSplitted.join('/')
    if (this.shareMode) {
      this.topic = `$share/${this.sessionName}/${this.topic}`
    }
    if (this.topicFilter) {
      this.topic = `$filter/${this.topicFilter}/${this.topic}`
    }
    this.paramsByTopic = paramsByTopic
  }

  getTopicData(topic: string) {
    const topicData: Record<string, string> = {}
    if (this.paramsByTopic) {
      const topicSplitted = topic.split('/')
      Object.keys(this.paramsByTopic)?.forEach((key) => {
        const paramName = this.paramsByTopic[key]
        topicData[paramName] = topicSplitted[parseInt(key)]
      })
    }
    return topicData
  }
}
